import  { useState } from 'react';
import { 
  Instagram, 
  Facebook, 
  Youtube, 
  Linkedin, 
  MessageCircle,
} from 'lucide-react';

const FloatingSocialWidget = () => {
  const [isExpanded] = useState(true); // Start expanded for testing

  const socialLinks = [
    {
      name: 'Instagram',
      icon: Instagram,
      url: 'https://www.instagram.com/kabco_tvm/',
      color: 'bg-gradient-to-r from-purple-500 to-pink-500',
      hoverColor: 'hover:from-purple-600 hover:to-pink-600'
    },
    {
      name: 'Facebook',
      icon: Facebook,
      url: 'https://www.facebook.com/profile.php?id=61568072270807',
      color: 'bg-blue-600',
      hoverColor: 'hover:bg-blue-700'
    },
    {
      name: 'YouTube',
      icon: Youtube,
      url: 'https://www.youtube.com/@KeralaAgroBusinessCompany',
      color: 'bg-red-600',
      hoverColor: 'hover:bg-red-700'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: 'https://www.linkedin.com/in/kabco/',
      color: 'bg-blue-700',
      hoverColor: 'hover:bg-blue-800'
    },
    {
      name: 'WhatsApp',
      icon: MessageCircle,
      url: 'https://wa.me/+919037879363',
      color: 'bg-green-500',
      hoverColor: 'hover:bg-green-600'
    }
  ];

  return (
    <div 
      className="fixed left-0 top-1/2 transform -translate-y-1/2 z-50"
      style={{ 
        position: 'fixed',
        left: '0px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 9999
      }}
    >
      <div 
        className={`flex items-center transition-all duration-300 ease-in-out ${
          isExpanded ? 'translate-x-0' : '-translate-x-48'
        }`}
        style={{
          transform: isExpanded ? 'translateX(0)' : 'translateX(-192px)'
        }}
      >
        {/* Social Icons Container */}
        <div className="bg-white rounded-r-lg shadow-lg border border-gray-200 overflow-hidden">
          <div className="flex flex-col">
            {socialLinks.map((social, index) => {
              const IconComponent = social.icon;
              return (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${social.color} ${social.hoverColor} p-3 transition-all duration-200 transform hover:scale-105 group relative`}
                  title={social.name}
                >
                  <IconComponent 
                    size={20} 
                    className="text-white transition-transform duration-200 group-hover:scale-110" 
                  />
                  
                  {/* Tooltip */}
                  <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white px-2 py-1 rounded text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                    {social.name}
                    <div className="absolute right-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-r-gray-800"></div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatingSocialWidget;